export const CLEAR_TRANSCRIPT = 'CLEAR_TRANSCRIPT'
export const APPEND_TRANSCRIPT = 'APPEND_TRANSCRIPT'
